module.exports = __webpack_public_path__ + "img/tab1.ee2a3cd5.png";